<script>
  import Label from "./Label.svelte";
  import { nanoid } from "nanoid";
  import clsx from "clsx";

  let className = "my-4";
  export { className as class };
  export let label;
  export let value;
  export let required = false;
  export let minRows = 2;
  export let maxRows;

  const id = "input-" + nanoid();

  $: minHeight = `${1 + minRows * 1.2}em`;
  $: maxHeight = maxRows ? `${1 + maxRows * 1.2}em` : `auto`;
</script>

<div class={clsx(className, "not-prose")}>
  <Label {id} {label} {required} />
  <div class="relative">
    <pre class="form-textarea overflow-hidden whitespace-pre-line font-sans opacity-0" aria-hidden="true" style="min-height: {minHeight}; max-height: {maxHeight}">{value + "\n"}</pre>
    <textarea {id} class="form-textarea absolute inset-0 w-full resize-none" {required} bind:value />
  </div>
</div>
